import ProductPreview from "@components/ProductPreview";

export default ProductPreview;
